export const GENRES = [
  "Trap",
  "Trance",
  "Roots",
  "Rock",
  "Reggae",
  "R&B/Soul",
  "Rap",
  "Punk",
  "Pop",
  "New Age",
  "Metal",
  "Latin",
  "Jazz",
  "Indie",
  "Hip-hop",
  "Gospel",
  "Electronic",
  "Disco",
  "Dance",
  "Country",
  "Contemporary Blues",
  "Classical",
  "Blues",
  "Alternative",
];

export const INSTRUMENTS = [
  "Vocals",           // vocalist: 53
  "Electric Guitar",  // guitar: 28
  "Acoustic Guitar",  // guitar: 28
  "Keys",             // keys: 21
  "Violin",           // strings: 19
  "Cello",            // strings: 19
  "Drums",            // drum: 17
  "Winds",            // winds: 17
  "Horns",            // winds: 17 
  "Bass",             // bass: 8
  "Beats",            // producer: 5
  "DJ",               // producer: 5
  "Accordion",        // accordion: 3
  "Percussion",       // percussion: 3
];
